import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';
import React, { CSSProperties } from 'react';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    // Platform card: rounded with the soft platform shadow (same as the shared Paper used on
    // the lender Draws page); grids inside sit flush (no card-in-card)
    root: {
      borderRadius: 24,
      boxShadow: theme.shadows[9],
      border: 'none',
      '& .ag-theme-alpine, & .ag-theme-alpine .ag-root-wrapper': {
        border: 'none !important',
        borderRadius: '0 !important',
      },
    },
    cardHeader: {
      padding: '16px 16px 0px 16px',
      '& .MuiCardHeader-action': {
        alignSelf: 'center',
        margin: 0,
      },
    },
    cardContent: {
      padding: 16,
      '&:last-child': {
        padding: 16,
      }
    }
  }),
);

interface BorrowerPortalCardProps {
  children?: any
  cardTitle?: any
  cardSubTitle?: string
  cardRootClassName?: string
  cardRootStyle?: CSSProperties
  cardHeaderClassName?: string
  cardHeaderStyle?: CSSProperties
  cardHeaderAction?: React.ReactNode
  cardContentClassName?: string
  cardFooterActions?: React.ReactNode
  cardFooterClassName?: string
  noPaddingCardContent?: boolean
}

export const BorrowerPortalCard = ({
  children,
  cardTitle,
  cardSubTitle,
  cardRootClassName,
  cardRootStyle,
  cardHeaderAction,
  cardHeaderClassName,
  cardHeaderStyle,
  cardContentClassName,
  cardFooterActions,
  cardFooterClassName,
  noPaddingCardContent = false,
}: BorrowerPortalCardProps) => {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <Card className={clsx(classes.root, cardRootClassName)} style={cardRootStyle ?? {}}>
      {
        (cardTitle || cardSubTitle || cardHeaderAction) &&
        <CardHeader
          action={cardHeaderAction}
          className={clsx(classes.cardHeader, cardHeaderClassName)}
          style={cardHeaderStyle ?? {}}
          title={cardTitle}
          titleTypographyProps={{
            variant: 'h5'
          }}
          subheader={cardSubTitle}
          subheaderTypographyProps={{
            variant: 'body2'
          }}
        />
      }
      <CardContent className={clsx(classes.cardContent, cardContentClassName)} style={noPaddingCardContent ? {
        padding: 0
      } : {}}>
        {children}
      </CardContent>
      {
        cardFooterActions &&
        <CardActions disableSpacing className={cardFooterClassName}>
          {cardFooterActions}
        </CardActions>
      }
    </Card >
  );
}
